var _defs, _tspan, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqqqe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "471.6145mm",
    height: "132.29167mm",
    viewBox: "0 0 471.6145 132.29167",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-9.0826126e-7,-164.70833)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D7\\uE1D5    \\uE1D5    \\uE1D5    \\uE1D7",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    id: "text108",
    transform: "matrix(1.3530099,0,0,1.3530099,-3.2062522e-7,-79.622225)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 43.415836,207.64271 c -4.930884,-7.57672 -9.01991,-15.51424 -10.463096,-24.77469 -0.360796,-1.56345 -1.082389,-2.04451 -2.886371,-2.04451 -0.481062,0 -0.962124,0.12027 -0.962124,0.84186 v 0.12027 c 0,0 0,0.24053 0,0.48106 v 22.60991 c 0,0 0,0 0,0 v 48.58725 c -1.924247,-1.68372 -4.570088,-2.52558 -7.69699,-2.52558 -11.9062818,0 -21.40725409173874,8.77938 -21.40725409173874,18.03982 0,5.65248 4.57008799173874,9.01991 10.46309609173874,9.01991 9.621238,0 21.52752,-8.89964 21.52752,-18.03982 V 205.959 c 5.893008,3.72822 12.988671,14.31159 15.995307,21.28698 1.443186,3.24717 2.285044,8.77938 2.285044,14.43186 0,4.32956 -0.601327,8.89965 -2.285044,13.2292 -0.120265,0.48106 -0.240531,0.96213 -0.240531,1.44319 0,1.44318 0.962124,2.40531 1.563452,2.7661 l 0.120265,0.12027 c 0.841858,0 2.044513,-0.3608 2.525575,-1.92425 0,0 2.525575,-9.14017 2.525575,-16.7169 0,-12.02655 -5.05115,-23.3315 -11.064424,-32.95274 z",
    id: "path213"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 83.599538,253.70439 c -1.924248,-1.68372 -4.570088,-2.52558 -7.69699,-2.52558 -11.906282,0 -21.407254,8.77938 -21.407254,18.16009 0,5.65248 4.570088,9.01991 10.463096,9.01991 9.621237,0 21.527519,-9.01991 21.527519,-18.16009 v -79.61574 h -2.886371 z",
    id: "path215"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 163.46333,253.70439 c -1.92425,-1.68372 -4.57009,-2.52558 -7.69699,-2.52558 -11.90628,0 -21.40725,8.77938 -21.40725,18.16009 0,5.65248 4.57008,9.01991 10.46309,9.01991 9.62124,0 21.52752,-9.01991 21.52752,-18.16009 v -79.61574 h -2.88637 z",
    id: "path217"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m 243.32712,253.70439 c -1.92425,-1.68372 -4.57009,-2.52558 -7.697,-2.52558 -11.90628,0 -21.40725,8.77938 -21.40725,18.16009 0,5.65248 4.57009,9.01991 10.4631,9.01991 9.62123,0 21.52752,-9.01991 21.52752,-18.16009 v -79.61574 h -2.88637 z",
    id: "path219"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 337.50251,207.64271 c -4.93089,-7.57672 -9.01991,-15.51424 -10.4631,-24.77469 -0.3608,-1.56345 -1.08239,-2.04451 -2.88637,-2.04451 -0.48106,0 -0.96212,0.12027 -0.96212,0.84186 v 0.12027 c 0,0 0,0.24053 0,0.48106 v 22.60991 c 0,0 0,0 0,0 v 48.58725 c -1.92425,-1.68372 -4.57009,-2.52558 -7.697,-2.52558 -11.90628,0 -21.40725,8.77938 -21.40725,18.03982 0,5.65248 4.57009,9.01991 10.4631,9.01991 9.62123,0 21.52752,-8.89964 21.52752,-18.03982 V 205.959 c 5.893,3.72822 12.98867,14.31159 15.9953,21.28698 1.44319,3.24717 2.28505,8.77938 2.28505,14.43186 0,4.32956 -0.60133,8.89965 -2.28505,13.2292 -0.12026,0.48106 -0.24053,0.96213 -0.24053,1.44319 0,1.44318 0.96213,2.40531 1.56345,2.7661 l 0.12027,0.12027 c 0.84186,0 2.04451,-0.3608 2.52557,-1.92425 0,0 2.52558,-9.14017 2.52558,-16.7169 0,-12.02655 -5.05115,-23.3315 -11.06442,-32.95274 z",
    id: "path221"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqqqe);
export default __webpack_public_path__ + "static/media/eqqqe.e563a566a660d5a44c84a9c8ce41535d.svg";
export { ForwardRef as ReactComponent };